import Urls from "../../api/endpoints";
import Table from "react-bootstrap/Table";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import Headings from "../../constants/headings";
import Constants from "../../constants/constants";
import React, { useEffect, useState, useCallback } from "react";
import { NotLogin, Loading } from "../../shared/index";
import { NidInquiryStatusType, LineStateStatusType } from "../../enums/index";
import {
  ErrorHandling,
  ToPersianNumber,
  DateToPersianNumber,
  getNidInquiryStatusClass,
  getNidInquiryStatusText,
} from "../../functions";
import Actions from "./actions/actions";
import headings from "../../constants/headings";
function LinesList(props) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [tableHeaders, setTableHeaders] = useState(
    Headings.ActivateLinesPageTableTitle
  );
  const [loading, setLoading] = useState(true);
  const [storedData, setStoredData] = useState(null);
  const [filter, setFilter] = useState(LineStateStatusType.Active());
  function changeBackground(e) {
    e.currentTarget.className = "hovered";
  }
  function changeBackgroundBack(e) {
    e.currentTarget.className = "";
  }
  const goToUserPage = async (uri) => {
    navigate(`/${uri}`);
  };
  const [dropDownFilter, setDropDownFilter] = useState(
    Headings.LinesDropDownItemsText(filter)
  );
  const setFilterValue = async (value) => {
    switch (value) {
      case 0:
        setFilter(LineStateStatusType.Active());
        setTableHeaders(headings.ActivateLinesPageTableTitle);
        setDropDownFilter(
          Headings.LinesDropDownItemsText(LineStateStatusType.Active())
        );
        setLoading(true);
        setReadyToActivateLines();
        break;
      case 1:
        setFilter(LineStateStatusType.RejectActivation());
        setTableHeaders(headings.RejectLinesPageTableTitle);
        setDropDownFilter(
          Headings.LinesDropDownItemsText(
            LineStateStatusType.RejectActivation()
          )
        );
        setLoading(true);
        setRejectedLines();
        break;
      default:
        setFilter(LineStateStatusType.Active());
        setTableHeaders(headings.ActivateLinesPageTableTitle);
        setDropDownFilter(
          Headings.LinesDropDownItemsText(LineStateStatusType.Active())
        );
        setLoading(true);
        setReadyToActivateLines();
        break;
    }
  };
  const setReadyToActivateLines = useCallback(() => {
    fetch(Urls.getNotConfirmedLinesList(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        data.sort(function (a, b) {
          return new Date(b.ActivationDate) - new Date(a.ActivationDate);
        });
        setStoredData(data);
        setData(data);
      })
      .catch((error) => {
        ErrorHandling(error, "search error");
      });
  }, [props.token]);
  const setRejectedLines = () => {
    fetch(Urls.getRejectedConfirmationCustomerLines(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        data.sort(function (a, b) {
          return new Date(b.ActivationDate) - new Date(a.ActivationDate);
        });
        setData(data);
      })
      .catch((error) => {
        ErrorHandling(error, "search error");
      });
  };
  useEffect(() => {
    setReadyToActivateLines();
  }, [setReadyToActivateLines]);
  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="top-margin"></div>
          <div className="user-info-container user-service-container">
            <div className="user-info">
              <h1>{Headings.ActivateLinesPageTitle}</h1>
              <div className="divider"></div>
              <Actions
                data={data}
                setData={setData}
                storedData={storedData}
                dropDownFilter={dropDownFilter}
                setFilter={setFilter}
                dropDownItems={headings.LinesDropDownItems}
                setFilterValue={setFilterValue}
              ></Actions>
          
              <Row>
                <Col>
                  <Table responsive className="roundedCorners">
                    <thead>
                      <tr>
                        {tableHeaders.map((h, index) => (
                          <th key={index}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data &&
                        data.map((d, index) => (
                          <tr
                            key={index}
                            onMouseOver={changeBackground}
                            onMouseOut={changeBackgroundBack}
                            onClick={() => {
                              props.setSearch(true);
                              props.setUserId(d.Id);
                              if (
                                d.NidInquiryStatus ===
                                  NidInquiryStatusType.ReadyForInquiry() ||
                                d.NidInquiryStatus ===
                                  NidInquiryStatusType.InProgress()
                              ) {
                                goToUserPage("authentication");
                              } else {
                                goToUserPage("lines");
                              }
                            }}
                          >
                            <td>{ToPersianNumber(index + 1)}</td>
                            <td className="ltr">
                              {" "}
                              {d.IsFree &&
                                Constants.AuthHistoryArray.open +
                                  Constants.Free +
                                  Constants.AuthHistoryArray.close}
                              {ToPersianNumber(d.LineNumber)}
                            </td>
                            <td>{d.CustomerFullName}</td>
                            <td
                              className={`td ${getNidInquiryStatusClass(
                                d.NidInquiryStatus
                              )}`}
                            >
                              {getNidInquiryStatusText(d.NidInquiryStatus)}
                            </td>
                            {filter === LineStateStatusType.Active() ? (
                              <td>
                                {DateToPersianNumber(d.PersianActivationDate)}
                              </td>
                            ) : (
                              <>
                                <td>
                                  {DateToPersianNumber(d.PersianRejectionDate)}
                                </td>
                                <td>{d.RejectionReason}</td>
                              </>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
          </div>
        </>
      )}
    </main>
  );
}
export default LinesList;
